import { render, staticRenderFns } from "./TransactionFile.vue?vue&type=template&id=11884749"
import script from "./TransactionFile.vue?vue&type=script&lang=js"
export * from "./TransactionFile.vue?vue&type=script&lang=js"
import style0 from "./TransactionFile.vue?vue&type=style&index=0&id=11884749&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports